import type { AxiosInstance } from 'axios';

export const download = async (client: AxiosInstance, url: string) => {
  return client.request<Blob>({ url, method: 'GET', responseType: 'blob' }).then(response => {
    const filename = new RegExp(/filename="(.+)"/).exec(response.headers['content-disposition']);
    return {
      blob: response.data,
      filename: filename?.length ? filename[1] : null,
    };
  });
};

export class UtilsClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  download = async (url: string) => {
    return download(this.authenticatedClient, url);
  };
}

export default UtilsClient;